<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <search-dsp-select v-model="dspId" :dspType="null" />

      <el-button @click="toQuery" type="primary" >发送</el-button>

    </div>
    <div class="table-wrapper">
      <p>请求参数：</p>
      <el-input type="textarea" :rows="20" placeholder="请输入内容" v-model="reqJson">
      </el-input>
      <p>响应参数：</p>
      <pre style="font-size: 18px;line-height: 24px;min-height: 320px;max-height:680px;border: 1px solid black;">{{ JSON.stringify(resJson,null,4) }}</pre>
    </div>

  </div>
</template>

<script>
import DateFormatSelect from '@/components/DateFormatSelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import { formatDate, PURE_DATETIME_H_PATTERN } from '@/util/format'
import TableColumn from '@/components/TableColumn'
import { downExcelMixin } from '@/mixins/downExcel'
import { mockReq } from '@/api/paramIntercept/mockReq'

import initTableMixin from '@/mixins/initTable'

export default {
  name: 'logBid',
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      // columns: [
      //   { field: 'timeHour', title: '时间' },
      //   { field: 'channelName', title: '渠道名称' },
      //   { field: 'dspName', title: 'DSP名称' },
      //   { field: 'slotId', title: '广告位编号' },
      //   { field: 'slotName', title: '广告位名称' },
      //   { field: 'dspSlotName', title: 'DSP广告位名称'},
      //   { field: 'resBody', title: '响应数据'},
      //   { field: 'dspResBody', title: '响应DSP数据'},
      // ],
      date: '',
      show: false,
      dspId: '',
      reqJson: `{
  "appBundle": "",
  "appId": ,
  "appName": "",
  "appVer": "",
  "brand": "",
  "carrier": ,
  "channelId": ,
  "connectionType": ,
  "deviceType": ,
  "h": ,
  "imei": "",
  "ip": "",
  "model": "",
  "oaid": "",
  "os": "",
  "osv": "",
  "queryWord": "",
  "reqStartTime": ,
  "slotId": ,
  "ua": "",
  "w":
}`,
      resJson: {}
    }
  },
  computed: {},
  mounted () { },
  methods: {
    beforeInit () {
      return false
    },
    toQuery () {
      mockReq({
        dspId: this.dspId,
        json: this.reqJson.replace(/[ ]|[\r\n]|\\/g, '')
      }).then(res => {
        this.resJson = res.data
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  height: 150vh;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

pre {
  white-space: pre-wrap;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
